import { useMutation, useQueryClient } from '@tanstack/react-query'
import { MUTATION_KEYS, QUERY_KEYS } from '@/config/tanstack-querykeys.config'
import { applyPerkAction } from '@/app/_actions/perks.actions'
import { ErrorType } from '@/types/errors.types'
import { unwrapActionResult } from '@/utils/errors.utils'
import { useSeller } from '@/app/_providers/SellerProvider/SellerProvider'
import { useCart } from '@/app/_providers/CartProvider/CartProvider'
import useHandleError from '@/hooks/useHandleError'

const useApplyPerk = (): {
  loading: boolean
  applyPerk: () => void
} => {
  const { cart } = useCart()
  const { id: sellerId } = useSeller()
  const queryClient = useQueryClient()
  const { handleError } = useHandleError()

  const { isPending, mutate } = useMutation({
    mutationKey: [MUTATION_KEYS.REDEEM_PERKS, cart?.id, sellerId],
    mutationFn: () => applyPerkAction(cart.id, sellerId).then(unwrapActionResult),
    onSuccess: (cartResponse) => {
      queryClient.setQueryData([QUERY_KEYS.CART, cartResponse.id], cartResponse)
    },
    onError: (err) => {
      handleError(err, ErrorType.RedeemPerk)
    },
  })

  const applyPerk = (): void => {
    mutate()
  }

  return {
    loading: isPending,
    applyPerk,
  }
}

export default useApplyPerk
